export default function WhyUseSection() {
  const cards = [
    {
      icon: "ri-search-eye-line",
      title: "Szybkie wyszukiwanie",
      description: "Znajdź produkty błyskawicznie dzięki uporządkowanej strukturze arkusza i zaawansowanym filtrom kategorii.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Zweryfikowane informacje",
      description: "Każdy link i produkt w naszym arkuszu przechodzi weryfikację, aby zapewnić Ci bezpieczne zakupy.",
    },
    {
      icon: "ri-scales-3-line",
      title: "Porównania produktów",
      description: "Porównuj ceny, jakość i opinie różnych produktów w jednym miejscu bez konieczności przeskakiwania między stronami.",
    },
    {
      icon: "ri-line-chart-line",
      title: "Aktualne trendy",
      description: "Bądź na bieżąco z najnowszymi trendami i sezonowymi nowościami dzięki cotygodniowym aktualizacjom arkusza.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight">
            Dlaczego warto korzystać z <span className="text-primary-600">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 mt-3 text-sm max-w-xl mx-auto leading-relaxed">
            Nasz arkusz został zaprojektowany, aby uprościć i usprawnić Twoje doświadczenia zakupowe na chińskich platformach.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${card.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {card.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}